import { MachinesListDataTypes } from "@common/types/machines-list-types";
import apiUseCases from "@src/cloud-connect/api";
import { postVPNInterruptSupportSessionDto } from "@src/cloud-connect/api/vpn-manager/vpn-post-interrupt-support-session";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";

export const postVPNInterruptSupportSessionUseCase = async (
  payload: postVPNInterruptSupportSessionDto,
): Promise<{
  success: boolean;
  data?: MachinesListDataTypes;
  error?: string;
}> => {
  try {
    const response = await apiUseCases.postVPNInterruptSupportSession(payload);

    return {
      success: true,
      data: response,
    };
  } catch (error) {
    return {
      success: false,
      error: parseAxiosApiError(error, "Failed to interrupt support session.")
        .message,
    };
  }
};
